export const caseStudyStatments = {
	castStudy1: {
		content:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry.  ',
	},
	castStudy2: {
		content:
			"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
	},
	castStudy3: {
		content:
			"Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
	},
};
